<template>
  <b-card-code
    :title="
      selectedDoor
        ? 'Dispositivos de la puerta: ' + selectedDoor.Name
        : 'Selecciona una puerta'
    "
    no-body>
    <b-card-body>
      <!-- Selector de Puertas -->
      <b-form-group label="" label-cols="12">
        <b-form-select
          v-model="selectedDoor"
          :options="[
            { value: 'all', text: 'TODOS LOS DIPOSITIVOS' },
            ...availableDoors.map((d) => ({
              value: d,
              text: `${d.Aforo_name} - ${d.Name}`,
            })),
          ]"
          @change="onSelectDoor"
          placeholder="Selecciona una puerta..." />
      </b-form-group>

      <b-table
        v-if="pkidDoor"
        :key="pkidDoor"
        striped
        hover
        responsive
        :items="items"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :per-page="perPage"
        :current-page="currentPage"
        class="position-relative">
        <template #cell(open_once)="data">
          <div
            class="text-center"
            @click="!isFetching && toggleOpenOnce(data.item)"
            style="cursor: pointer">
            <img
              v-if="data.item.open_once === 1"
              src="@/assets/images/icons/porta-oberta.png"
              alt="Puerta abierta"
              style="height: 30px" />
            <img
              v-else
              src="@/assets/images/icons/porta-tancada.png"
              alt="Puerta cerrada"
              style="height: 30px" />
          </div>
        </template>

        <template #cell(mantain_open)="data">
          <b-form-checkbox
            switch
            size="lg"
            :checked="!!data.item.mantain_open"
            @change="toggleMantainOpen(data.item)"
            :disabled="isFetching" />
        </template>
        <template #cell(active)="data">
          <b-badge :variant="activeLabel[1][data.value]">
            {{ activeLabel[0][data.value] }}
          </b-badge>
        </template>
        <template #cell(isExitVisitor)="data">
          <b-badge :variant="activeExit[1][data.value]">
            {{ activeExit[0][data.value] }}
          </b-badge>
        </template>
      </b-table>
    </b-card-body>

    <b-card-body
      v-if="pkidDoor"
      class="d-flex justify-content-between flex-wrap pt-0">
      <b-form-group
        label="Por página"
        label-cols="6"
        label-align="left"
        label-size="sm"
        class="text-nowrap mb-md-0 mr-1">
        <b-form-select
          v-model="perPage"
          size="sm"
          inline
          :options="pageOptions"
          @change="onPerPageChange" />
      </b-form-group>

      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        @input="onPageChange">
        <template #prev-text>
          <feather-icon icon="ChevronLeftIcon" size="18" />
        </template>
        <template #next-text>
          <feather-icon icon="ChevronRightIcon" size="18" />
        </template>
      </b-pagination>
    </b-card-body>
  </b-card-code>
</template>

<script>
import axios from "@/libs/axios";
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import moment from "moment";
import { decryptString } from "@/libs/crypto";
import {
  BTable,
  BFormGroup,
  BBadge,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BCardBody,
  BButton,
  BFormCheckbox,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    BCardCode,
    BTable,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BCardBody,
    BButton,
    BFormCheckbox,
    flatPickr,
    BBadge,
  },
  data() {
    return {
      items: [],
      isFetching: false,
      perPage: 50,
      pageOptions: [50, 100, 200, 500],
      totalRows: 0,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      pkidDoor: null,
      selectedDoor: null,
      availableDoors: [],
      fields: [],
      activeLabel: [
        {
          0: "Inactivo",
          1: "Activo",
        },
        {
          0: "light-danger",
          1: "light-success",
        },
      ],
      activeExit: [
        {
          0: "No",
          1: "Si",
        },
        {
          0: "light-danger",
          1: "light-success",
        },
      ],
      refreshInterval: null,
      pollInterval: 3000,
    };
  },
  computed: {
    sortOptions() {
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({
          text: f.label,
          value: f.key,
        }));
    },
  },
  methods: {
    async fetchDoors() {
      try {
        const response = await axios.get(
          "/aforodoor?ID_Aforo=" +
            decryptString(localStorage.getItem("Aforo_permit"))
        );
        this.availableDoors = response.data;
      } catch (error) {
        this.$bvToast.toast("Fallo al obtener las puertas", {
          title: `${error}`,
          variant: "danger",
          solid: true,
        });
      }
    },
    async onSelectDoor() {
      if (this.selectedDoor) {
    // Usa 'all' si seleccionó "Todas las puertas"
          if (this.selectedDoor === 'all') {
            this.pkidDoor = 'all';
          } else {
            this.pkidDoor = this.selectedDoor.fkid_door || this.selectedDoor.pkid_door;
          }

          if (!this.pkidDoor) {
            console.error("No se encontró fkid_door en el objeto:", this.selectedDoor);
            return;
          }
        await this.fetchDevices();
      } else {
        this.pkidDoor = null;
        this.items = [];
        this.totalRows = 0;
      }
    },
    async fetchDevices() {
      this.isFetching = true;
      try {
        const response = await axios.get(`/dooraccesdevices/${this.pkidDoor}`);

        // Asegura reactividad para cada dispositivo
        this.items = response.data.map((device) => {
          return {
            ...device,
            open_once: device.open_once ? 1 : 0, // Fuerza valor numérico
            mantain_open: device.mantain_open > 0 && device.mantain_open < 3 ? 1 : 0,
          };
        });

        this.totalRows = this.items.length;
        this.fields = [
          { key: "Aforo_name", label: "Aforo", sortable: true },
          { key: "name", label: "Nombre", sortable: true },
          {
            key: "open_once",
            label: "Abrir Una Vez",
            sortable: true,
            thStyle: { textAlign: "center" },
          },
          { key: "mantain_open", label: "Mantener Abierto", sortable: true },
          { key: "active", label: "Estado", sortable: true },
          { key: "isExitVisitor", label: "Salir", sortable: true}
        ];
      } catch (error) {
        console.error("Error al obtener dipositivos:", error);
      } finally {
        this.isFetching = false;
      }
    },

    async toggleOpenOnce(item) {
      if (this.isFetching) return;
      try {
        this.isFetching = true;
        const newValue = item.open_once === 1 ? 0 : 1;

        // Actualización reactiva
        this.$set(item, "open_once", newValue);

        const response = await axios.put(`/devices/${item.pkiddevice}`, {
          open_once: newValue,
          mantain_open: item.mantain_open,
          timestamp_modification: moment.utc().toISOString(),
        });

        this.$toast.success(
          `Open Once ${newValue ? "activado" : "desactivado"}`
        );
      } catch (error) {
        this.$toast.error("Error al actualizar Abrir una vez");
        console.error("Azctualizar error:", error);
      } finally {
        this.isFetching = false;
      }
    },
    async toggleMantainOpen(item) {
      try {
        this.isFetching = true;
        const newValue = !item.mantain_open;
        item.mantain_open = newValue;
        const utcNow = moment.utc().toISOString();
        const response = await axios.put(`/devices/${item.pkiddevice}`, {
          mantain_open: newValue ? 1 : 3,
          open_once: item.open_once,
          timestamp_modification: utcNow,
        });
        if (response.data) Object.assign(item, response.data);
        this.$toast.success(
          `Mantain Open ${newValue ? "activado" : "desactivado"}`
        );
      } catch (error) {
        this.$toast.error("Error al actualizar Mantener Abierto");
      } finally {
        this.isFetching = false;
      }
    },
    onPageChange() {
      if (this.pkidDoor) this.fetchDevices();
    },
    onPerPageChange() {
      this.currentPage = 1;
      if (this.pkidDoor) this.fetchDevices();
    },
    startPolling() {
      if (this.refreshInterval) return;

      this.refreshInterval = setInterval(() => {
        if (this.pkidDoor && !this.isFetching) {
          this.fetchDevices();
        }
      }, this.pollInterval);
    },

    stopPolling() {
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
        this.refreshInterval = null;
      }
    },
  },
  created() {
    this.fetchDoors().then(() => {
    this.selectedDoor = 'all';
    this.onSelectDoor();
  });
  },
  mounted() {
    if (!localStorage.getItem("accessToken")) this.$router.go(0);
    this.startPolling();
  },
  beforeDestroy() {
    this.stopPolling();
  },
};
</script>

<style scoped>
.colModify {
  width: 0px;
}
</style>
